// Generat automat din README.md
import React, { useState } from 'react';
import { Package, TrendingUp, Calendar, Search, Filter, Download, MoreVertical, Eye, Edit, Trash2, ShoppingCart, Users, DollarSign, Clock } from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const IstoricComenzi = () => {
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [filterStatus, setFilterStatus] = useState('Toate');
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilter, setDateFilter] = useState('toate');

  // Mock data pentru comenzi detaliate
  const ordersData = {
    overview: {
      totalOrders: 247,
      thisMonth: 45,
      totalRevenue: '125,430.00',
      averageOrderValue: '508.25'
    },
    orders: [
      {
        id: 'ORD-2024-001',
        client: 'Compania ABC SRL',
        clientEmail: 'contact@abc-srl.ro',
        date: '2024-03-15',
        status: 'Livrată',
        priority: 'Înaltă',
        products: [
          { name: 'Servicii IT Premium', quantity: 1, unitPrice: 5000, total: 5000 },
          { name: 'Consultanță tehnică', quantity: 5, unitPrice: 300, total: 1500 }
        ],
        subtotal: 6500,
        tax: 1235,
        total: 7735,
        paymentMethod: 'Transfer bancar',
        paymentStatus: 'Plătit',
        shippingAddress: 'Strada Victoriei 15, București',
        deliveryDate: '2024-03-18',
        notes: 'Client VIP - prioritate maximă'
      },
      {
        id: 'ORD-2024-002',
        client: 'Business Pro SA',
        clientEmail: 'office@businesspro.ro',
        date: '2024-03-14',
        status: 'În procesare',
        priority: 'Medie',
        products: [
          { name: 'Licențe software', quantity: 10, unitPrice: 150, total: 1500 },
          { name: 'Suport tehnic', quantity: 1, unitPrice: 500, total: 500 }
        ],
        subtotal: 2000,
        tax: 380,
        total: 2380,
        paymentMethod: 'Card',
        paymentStatus: 'Plătit',
        shippingAddress: 'Bulevardul Magheru 32, București',
        deliveryDate: '2024-03-20',
        notes: 'Livrare rapidă solicitată'
      },
      {
        id: 'ORD-2024-003',
        client: 'StartUp Innovation SRL',
        clientEmail: 'hello@startup-inn.ro',
        date: '2024-03-12',
        status: 'În așteptare plată',
        priority: 'Scăzută',
        products: [
          { name: 'Servicii marketing', quantity: 1, unitPrice: 1200, total: 1200 },
          { name: 'Design logo', quantity: 1, unitPrice: 350, total: 350 }
        ],
        subtotal: 1550,
        tax: 294.5,
        total: 1844.5,
        paymentMethod: 'Transfer bancar',
        paymentStatus: 'Neplătit',
        shippingAddress: 'Calea Dorobanților 45, Cluj-Napoca',
        deliveryDate: '2024-03-25',
        notes: 'Client nou - urmărire plată'
      },
      {
        id: 'ORD-2024-004',
        client: 'Tech Solutions Ltd',
        clientEmail: 'contact@techsol.com',
        date: '2024-03-10',
        status: 'Anulată',
        priority: 'Medie',
        products: [
          { name: 'Dezvoltare aplicație', quantity: 1, unitPrice: 8000, total: 8000 }
        ],
        subtotal: 8000,
        tax: 1520,
        total: 9520,
        paymentMethod: 'Transfer bancar',
        paymentStatus: 'Refund procesează',
        shippingAddress: 'Digital delivery',
        deliveryDate: 'N/A',
        notes: 'Anulat la cererea clientului - proces refund'
      },
      {
        id: 'ORD-2024-005',
        client: 'Fashion Retail SRL',
        clientEmail: 'orders@fashionret.ro',
        date: '2024-03-08',
        status: 'Expediat',
        priority: 'Înaltă',
        products: [
          { name: 'Sistem POS', quantity: 2, unitPrice: 750, total: 1500 },
          { name: 'Training utilizatori', quantity: 1, unitPrice: 400, total: 400 }
        ],
        subtotal: 1900,
        tax: 361,
        total: 2261,
        paymentMethod: 'Card',
        paymentStatus: 'Plătit',
        shippingAddress: 'Strada Unirii 78, Timișoara',
        deliveryDate: '2024-03-11',
        notes: 'Urmărire AWB: RO123456789'
      },
      {
        id: 'ORD-2024-006',
        client: 'Medical Center Plus',
        clientEmail: 'admin@medplus.ro',
        date: '2024-03-06',
        status: 'Livrată',
        priority: 'Înaltă',
        products: [
          { name: 'Software medical', quantity: 1, unitPrice: 3500, total: 3500 },
          { name: 'Implementare și configurare', quantity: 1, unitPrice: 1200, total: 1200 }
        ],
        subtotal: 4700,
        tax: 893,
        total: 5593,
        paymentMethod: 'Transfer bancar',
        paymentStatus: 'Plătit',
        shippingAddress: 'Bulevardul Carol I 156, Iași',
        deliveryDate: '2024-03-09',
        notes: 'Implementare finalizată cu succes'
      }
    ],
    salesTrends: [
      { period: 'Ian 2024', orders: 38, revenue: 45320 },
      { period: 'Feb 2024', orders: 42, revenue: 52180 },
      { period: 'Mar 2024', orders: 45, revenue: 58930 }
    ]
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Livrată': return 'success';
      case 'Expediat': return 'info';
      case 'În procesare': return 'warning';
      case 'În așteptare plată': return 'warning';
      case 'Anulată': return 'error';
      default: return 'default';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'Înaltă': return 'error';
      case 'Medie': return 'warning';
      case 'Scăzută': return 'info';
      default: return 'default';
    }
  };

  const getPaymentStatusColor = (status) => {
    switch (status) {
      case 'Plătit': return 'success';
      case 'Neplătit': return 'error';
      case 'Refund procesează': return 'warning';
      default: return 'default';
    }
  };

  // Filtrarea comenzilor
  const filteredOrders = ordersData.orders.filter(order => {
    const matchesSearch = order.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         order.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'Toate' || order.status === filterStatus;
    
    let matchesDate = true;
    if (dateFilter !== 'toate') {
      const orderDate = new Date(order.date);
      const today = new Date();
      const daysDiff = Math.floor((today - orderDate) / (1000 * 60 * 60 * 24));
      
      switch (dateFilter) {
        case '7':
          matchesDate = daysDiff <= 7;
          break;
        case '30':
          matchesDate = daysDiff <= 30;
          break;
        case '90':
          matchesDate = daysDiff <= 90;
          break;
      }
    }
    
    return matchesSearch && matchesStatus && matchesDate;
  });

  const orderColumns = [
    { 
      header: 'Comandă', 
      key: 'id',
      render: (value, row) => (
        <div>
          <div className="font-medium text-gray-900 dark:text-white">{value}</div>
          <div className="text-sm text-gray-500">{row.date}</div>
        </div>
      )
    },
    { 
      header: 'Client', 
      key: 'client',
      render: (value, row) => (
        <div>
          <div className="font-medium">{value}</div>
          <div className="text-sm text-gray-500">{row.clientEmail}</div>
        </div>
      )
    },
    { 
      header: 'Produse', 
      key: 'products',
      render: (products) => (
        <div className="text-sm">
          <div className="font-medium">{products.length} produs{products.length !== 1 ? 'e' : ''}</div>
          <div className="text-gray-500 truncate max-w-32">
            {products[0]?.name}{products.length > 1 ? '...' : ''}
          </div>
        </div>
      )
    },
    { 
      header: 'Total', 
      key: 'total',
      render: (value) => (
        <span className="font-bold text-primary-600">{value.toLocaleString('ro-RO')} RON</span>
      )
    },
    { 
      header: 'Status', 
      key: 'status',
      render: (value) => <Badge variant={getStatusColor(value)}>{value}</Badge>
    },
    { 
      header: 'Prioritate', 
      key: 'priority',
      render: (value) => <Badge variant={getPriorityColor(value)}>{value}</Badge>
    },
    { 
      header: 'Plată', 
      key: 'paymentStatus',
      render: (value) => <Badge variant={getPaymentStatusColor(value)}>{value}</Badge>
    },
    {
      header: 'Acțiuni',
      key: 'actions',
      render: (_, row) => (
        <div className="flex space-x-1">
          <button
            onClick={() => {
              setSelectedOrder(row);
              setShowOrderModal(true);
            }}
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            title="Vezi detalii"
          >
            <Eye className="w-4 h-4" />
          </button>
          <button
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            title="Editează"
          >
            <Edit className="w-4 h-4" />
          </button>
          <button
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded text-red-500"
            title="Șterge"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      )
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Istoric Comenzi</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Vizualizare completă a comenzilor cu filtrare avansată și analize detaliate
          </p>
        </div>
        <div className="flex space-x-3">
          <button className="btn-secondary">
            <Download className="w-4 h-4 mr-2" />
            Export
          </button>
          <button className="btn-primary">
            <Package className="w-4 h-4 mr-2" />
            Comandă Nouă
          </button>
        </div>
      </div>

      {/* Overview Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card title="Total Comenzi" subtitle="Toate perioadele" icon={ShoppingCart}>
          <div className="text-2xl font-bold text-primary-600">{ordersData.overview.totalOrders}</div>
          <div className="text-sm text-blue-600">În baza de date</div>
        </Card>
        <Card title="Luna Curentă" subtitle="Comenzi martie 2024" icon={Calendar}>
          <div className="text-2xl font-bold text-primary-600">{ordersData.overview.thisMonth}</div>
          <div className="text-sm text-green-600">+18% față de februarie</div>
        </Card>
        <Card title="Venituri Totale" subtitle="Facturat în martie" icon={DollarSign}>
          <div className="text-2xl font-bold text-primary-600">{ordersData.overview.totalRevenue} RON</div>
          <div className="text-sm text-green-600">+25% creștere</div>
        </Card>
        <Card title="Valoare Medie" subtitle="Pe comandă" icon={TrendingUp}>
          <div className="text-2xl font-bold text-primary-600">{ordersData.overview.averageOrderValue} RON</div>
          <div className="text-sm text-green-600">Trend crescător</div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        <div className="lg:col-span-3">
          <Card title="Lista Comenzilor" subtitle="Toate comenzile cu filtrare avansată">
            {/* Filtre și căutare */}
            <div className="mb-4 grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  placeholder="Caută comandă sau client..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-4 py-2 w-full border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
                />
              </div>
              
              <select 
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
              >
                <option value="Toate">Toate statusurile</option>
                <option value="Livrată">Livrată</option>
                <option value="Expediat">Expediat</option>
                <option value="În procesare">În procesare</option>
                <option value="În așteptare plată">În așteptare plată</option>
                <option value="Anulată">Anulată</option>
              </select>

              <select 
                value={dateFilter}
                onChange={(e) => setDateFilter(e.target.value)}
                className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
              >
                <option value="toate">Toate perioadele</option>
                <option value="7">Ultima săptămână</option>
                <option value="30">Ultima lună</option>
                <option value="90">Ultimele 3 luni</option>
              </select>

              <button className="btn-secondary">
                <Filter className="w-4 h-4 mr-2" />
                Filtre avansate
              </button>
            </div>

            {/* Rezultate filtrare */}
            <div className="mb-4 text-sm text-gray-600 dark:text-gray-400">
              Afișez {filteredOrders.length} din {ordersData.orders.length} comenzi
            </div>

            <Table columns={orderColumns} data={filteredOrders} />
          </Card>
        </div>

        <div className="space-y-6">
          <Card title="Distribuție Status" icon={Package}>
            <div className="space-y-3">
              {[
                { status: 'Livrată', count: 125, color: 'bg-green-500', percentage: 51 },
                { status: 'În procesare', count: 45, color: 'bg-yellow-500', percentage: 18 },
                { status: 'Expediat', count: 35, color: 'bg-blue-500', percentage: 14 },
                { status: 'În așteptare', count: 30, color: 'bg-orange-500', percentage: 12 },
                { status: 'Anulată', count: 12, color: 'bg-red-500', percentage: 5 }
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className={`w-3 h-3 rounded-full ${item.color}`}></div>
                    <span className="text-sm">{item.status}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-16 bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                      <div 
                        className={`${item.color} h-2 rounded-full transition-all duration-300`}
                        style={{ width: `${item.percentage}%` }}
                      ></div>
                    </div>
                    <span className="text-sm font-medium w-8 text-right">{item.count}</span>
                  </div>
                </div>
              ))}
            </div>
          </Card>

          <Card title="Comenzi pe Lună" icon={TrendingUp}>
            <div className="space-y-4">
              {ordersData.salesTrends.map((trend, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                  <div>
                    <div className="font-medium">{trend.period}</div>
                    <div className="text-sm text-gray-500">{trend.orders} comenzi</div>
                  </div>
                  <div className="text-right">
                    <div className="font-bold text-primary-600">{trend.revenue.toLocaleString('ro-RO')} RON</div>
                    <div className="text-xs text-green-600">+{((trend.revenue / (index > 0 ? ordersData.salesTrends[index-1].revenue : trend.revenue) - 1) * 100).toFixed(1)}%</div>
                  </div>
                </div>
              ))}
            </div>
          </Card>

          <Card title="Acțiuni Rapide">
            <div className="space-y-3">
              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Export Excel</span>
                  <Download className="w-4 h-4 text-gray-400" />
                </div>
              </button>
              
              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Raport Monthly</span>
                  <span className="text-xs text-gray-500">PDF</span>
                </div>
              </button>
              
              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Urmărire Livrări</span>
                  <Clock className="w-4 h-4 text-gray-400" />
                </div>
              </button>
            </div>
          </Card>
        </div>
      </div>

      {/* Modal pentru detaliile comenzii */}
      <Modal
        isOpen={showOrderModal}
        onClose={() => {
          setShowOrderModal(false);
          setSelectedOrder(null);
        }}
        title={`Detalii Comandă ${selectedOrder?.id || ''}`}
      >
        {selectedOrder && (
          <div className="space-y-6">
            {/* Informații generale */}
            <div className="grid grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Informații Comandă</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">ID Comandă:</span>
                    <span className="font-medium">{selectedOrder.id}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Data:</span>
                    <span>{selectedOrder.date}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Status:</span>
                    <Badge variant={getStatusColor(selectedOrder.status)}>{selectedOrder.status}</Badge>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Prioritate:</span>
                    <Badge variant={getPriorityColor(selectedOrder.priority)}>{selectedOrder.priority}</Badge>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Informații Client</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Client:</span>
                    <span className="font-medium">{selectedOrder.client}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Email:</span>
                    <span>{selectedOrder.clientEmail}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Adresa livrare:</span>
                    <span className="text-right">{selectedOrder.shippingAddress}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Produse */}
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Produse Comandate</h4>
              <div className="overflow-hidden border border-gray-200 dark:border-gray-700 rounded-lg">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Produs</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Cant.</th>
                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Preț unitar</th>
                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Total</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                    {selectedOrder.products.map((product, index) => (
                      <tr key={index}>
                        <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-white">{product.name}</td>
                        <td className="px-4 py-3 text-sm text-center text-gray-700 dark:text-gray-300">{product.quantity}</td>
                        <td className="px-4 py-3 text-sm text-right text-gray-700 dark:text-gray-300">{product.unitPrice.toLocaleString('ro-RO')} RON</td>
                        <td className="px-4 py-3 text-sm text-right font-medium text-gray-900 dark:text-white">{product.total.toLocaleString('ro-RO')} RON</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
              {/* Total comandă */}
              <div className="mt-4 bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span>Subtotal:</span>
                    <span>{selectedOrder.subtotal.toLocaleString('ro-RO')} RON</span>
                  </div>
                  <div className="flex justify-between">
                    <span>TVA (19%):</span>
                    <span>{selectedOrder.tax.toLocaleString('ro-RO')} RON</span>
                  </div>
                  <div className="flex justify-between border-t pt-2 font-bold text-lg">
                    <span>Total:</span>
                    <span className="text-primary-600">{selectedOrder.total.toLocaleString('ro-RO')} RON</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Informații plată și livrare */}
            <div className="grid grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Informații Plată</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Metoda de plată:</span>
                    <span>{selectedOrder.paymentMethod}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Status plată:</span>
                    <Badge variant={getPaymentStatusColor(selectedOrder.paymentStatus)}>{selectedOrder.paymentStatus}</Badge>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Informații Livrare</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Data livrare:</span>
                    <span>{selectedOrder.deliveryDate}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Note */}
            {selectedOrder.notes && (
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Observații</h4>
                <div className="bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-lg">
                  <p className="text-sm text-yellow-800 dark:text-yellow-200">{selectedOrder.notes}</p>
                </div>
              </div>
            )}

            {/* Acțiuni */}
            <div className="flex justify-end space-x-3 pt-4 border-t">
              <button className="btn-secondary">
                <Download className="w-4 h-4 mr-2" />
                Export Factură
              </button>
              <button className="btn-secondary">
                <Edit className="w-4 h-4 mr-2" />
                Editează
              </button>
              <button 
                className="btn-primary"
                onClick={() => {
                  setShowOrderModal(false);
                  setSelectedOrder(null);
                }}
              >
                Închide
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default IstoricComenzi;